<template>
  <div class="found_container" id="found_container" ref="found_container">
    <div>
      <div class="circletab" ref="circletab">
        <div class="found_top">
          <ul class="circleul">
            <li :class="liindex==1 ? 'active' : '' " data-index="1" @click="changeliindex">
              <span>最新</span>
            </li>
            <li :class="liindex==2 ? 'active' : '' " data-index="2" @click="changeliindex">
              <span>最热</span>
            </li>
          </ul>
          <van-search left-icon="https://api.xianpipa.com/xianpipa/images/contacts_icon_search.png" shape="round" placeholder="搜索喜欢的内容" v-model="value" @search="onSearch" @clear="onClear" @input="onChange" />
        </div>
        <div v-if="liindex==1">
          <van-list v-if="findFunsList != 0" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div class="findbigbox" ref="findbigbox">
              <div v-for="(item,index) in findFunsList" :key="index">
                <div class="findcellbox">
                  <div class="findtempbox">
                    <div class="findtempimgbox">
                      <div v-if="item.extra" @click="gotocircledetails" :data-id="item.id">
                        <img class="thumb" style="width: 100%;" v-lazy="item.thumb" />
                      </div>
                      <img v-if="!item.extra" @click="gotocircledetails" :data-id="item.id" :src="tou" />
                      <div v-if="item.msg_type == 2" class="videoicon">
                        <img :src="findIconPlay" />
                      </div>
                      <div class="authtitlebox">
                        <div class="authtitle-left">
                          <img v-if="item.user_avatar_url" :src="item.user_avatar_url" />
                          <img v-else :src="avatar_url" />
                        </div>
                        <div class="authtitle-right">
                          <img :src="findIconApplause" />
                          <span>{{item.nices_num}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="findtemptitlebox">
                      <div class="findtemptext">{{item.content}}</div>
                      <div class="findtitile-downbox">
                        <div v-if="item.is_follow == 0" class="authorfllow" @click="favorclick" :data-id="item.id">
                          <button>
                            <span class="cuIcon-add"></span>关注
                          </button>
                        </div>
                        <div v-if="item.is_follow == 1" class="authorfllow unfollow" @click="favorclick" :data-id="item.id">
                          <button>已关注</button>
                        </div>
                        <div class="authorbox" @click.stop="gotocirclecontent" :data-id="item.like_id">
                          <img :src="dynamicIconQz" />
                          <span>{{item.like_title}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-list>

          <div class="nofollowbox" v-if="findFunsList.length == 0">
            <div class="nofollowpic">
              <img :src="circleIconWu" />
            </div>
            <div class="nosearchtext">暂无搜索信息</div>
          </div>
        </div>
        <div v-if="liindex==2">
          <van-list v-if="findFunsList != 0" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <div class="findbigbox" ref="findbigbox">
              <!--  <div>
               
              </div>-->
              <div v-for="(item,index) in findFunsList" :key="index" class="findcellbox">
                <div class="findtempbox">
                  <div class="findtempimgbox">
                    <div v-if="item.extra" @click="gotocircledetails" :data-id="item.id">
                      <img class="thumb" style="width: 100%;" v-lazy="item.thumb" />
                    </div>
                    <img v-if="!item.extra" @click="gotocircledetails" :data-id="item.id" :src="tou" />
                    <div v-if="item.msg_type == 2" class="videoicon">
                      <img :src="findIconPlay" />
                    </div>
                    <div class="authtitlebox">
                      <div class="authtitle-left">
                        <img v-if="item.user_avatar_url" :src="item.user_avatar_url" />
                        <img v-else :src="avatar_url" />
                      </div>
                      <div class="authtitle-right">
                        <img :src="findIconApplause" />
                        <span>{{item.nices_num}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="findtemptitlebox">
                    <div class="findtemptext">{{item.content}}</div>
                    <div class="findtitile-downbox">
                      <div v-if="item.is_follow == 0" class="authorfllow" @click="favorclick" :data-id="item.id">
                        <button>
                          <span class="cuIcon-add"></span>关注
                        </button>
                      </div>
                      <div v-if="item.is_follow == 1" class="authorfllow unfollow" @click="favorclick" :data-id="item.id">
                        <button>已关注</button>
                      </div>
                      <div class="authorbox" @click.stop="gotocirclecontent" :data-id="item.like_id">
                        <img :src="dynamicIconQz" />
                        <span>{{item.like_title}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-list>

          <div class="nofollowbox" v-if="findFunsList.length == 0">
            <div class="nofollowpic">
              <img :src="circleIconWu" />
            </div>
            <div class="nosearchtext">暂无搜索信息</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFindFuns, gettofollowcircle } from "../../api/api";

import Vue from "vue";
import { Search, Toast, List } from "vant";

Vue.use(List);
Vue.use(Search);
Vue.use(Toast);

export default {
  data () {
    return {
      liindex: 1,
      value: "",
      findFunsList: [],
      loading: false,
      finished: false,
      page: 0,
      pageCount: 0,
      findIconPlay: require("../../assets/images/find_icon_play.png"),
      findIconApplause: require("../../assets/images/find_icon_applause.png"),
      dynamicIconQz: require("../../assets/images/dynamic_icon_qz.png"),
      circleIconWu: require("../../assets/images/circle_icon_wu.png"),
      tou: require("../../assets/images/tou1.jpg"),
      avatar_url: require("../../assets/images/moren.jpg")
    };
  },
  created () {
    this.getnewlist();
    document.title = "发现";
  },
  beforeRouteEnter (to, from, next) {
    if (from.name == "circlecontent" || from.name == "dynamicdetails") {
      // 这个name是下一级页面的路由name
      to.meta.keepAlive = true;
    } else {
      to.meta.keepAlive = false;
    }
    next();
  },
  mounted () { },
  methods: {
    onLoad () {
      // 异步更新数据
      setTimeout(() => {
        let pageCount = this.pageCount;
        var page = this.page;
        page++;
        if (page > pageCount) {
          this.loading = false;
          this.finished = true;
          return;
        }
        this.page = page;
        this.getmorenewlist();
      }, 1000);
    },
    changeliindex: function (e) {
      this.value = "";
      this.liindex = e.currentTarget.dataset.index;
      this.page = 0;
      this.loading = false;
      this.finished = false;

      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });

      this.getnewlist();
    },
    //初始化最新和最热列表
    getnewlist: function () {
      Toast.loading({
        mask: true,
        message: "加载中..."
      });
      let that = this;
      let sort = this.liindex;
      let keyword = this.value ? this.value : "";
      let data = {
        keyword: keyword,
        sort: sort,
        page: 0
      };
      getFindFuns(data)
        .then(res => {
          if (res.data.code == 200) {
            Toast.clear();
            let findFunsList = res.data.data.list;
            findFunsList.filter(item => {
              if (item.content.length > 22) {
                item.content = item.content.slice(0, 22) + "...";
              }
              if (item.like_title.length > 5) {
                item.like_title = item.like_title.slice(0, 5) + "...";
              }
            });

            let pageCount = null;
            if (res.data.data.pageCount) {
              pageCount = res.data.data.pageCount;
            }
            that.findFunsList = findFunsList;
            that.pageCount = pageCount;
            that.page = 0;
            that.finished = false;
            that.loading = false;
          } else {
            Toast(res.message);
          }
        })
        .catch(err => {
        });
    },
    //切割数组
    group: function (array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, (index += subGroupLength)));
      }
      return newArray;
    },

    //加载最新和最热列表
    getmorenewlist: function () {
      let that = this;
      let page = this.page;
      let sort = this.liindex;
      let keyword = this.value ? this.value : "";
      let data = {
        keyword: keyword,
        sort: sort,
        page: page
      };
      getFindFuns(data).then(res => {
        if (res.data.code == 200) {
          let findFunsList = res.data.data.list;
          if (findFunsList.length != 0) {
            findFunsList.filter(item => {
              if (item.content.length > 22) {
                item.content = item.content.slice(0, 22) + "...";
              }
              if (item.like_title.length > 5) {
                item.like_title = item.like_title.slice(0, 5) + "...";
              }
            });
            let oldnewList = that.findFunsList;
            let oldnewListLength = Math.ceil(oldnewList.length / 2);

            that.group(oldnewList, oldnewListLength);
            let oldnewList0 = that.group(oldnewList, oldnewListLength)[0];
            let oldnewList1 = that.group(oldnewList, oldnewListLength)[1];
            let findFunsList0 = that.group(findFunsList, 3)[0];
            let findFunsList1 = that.group(findFunsList, 3)[1] || [];

            findFunsList0.forEach((item, index) => {
              oldnewList0.push(item);
            });
            findFunsList1.forEach((item, index) => {
              oldnewList1.push(item);
            });
            oldnewList1.forEach((item, index) => {
              oldnewList0.push(item);
            });
            /*  findFunsList.forEach((item,index) => {
            oldnewList.push(item);
          }); */
            /*  that.findFunsList = oldnewList; */
            that.findFunsList = oldnewList0;
          }

          let pageCount = null;
          if (res.data.data.pageCount) {
            pageCount = res.data.data.pageCount;
          }
          this.loading = false;
        } else {
          Toast(res.message);
        }
      });
    },
    //关注圈子和取消关注圈子
    goodfllow: function (id) {
      var that = this;
      var like_id = ""; //圈子id
      var cookie_mid = this.$store.getters.getZan || []; //获取全部点赞的id

      var newmessage = [];
      for (var i = 0; i < that.findFunsList.length; i++) {
        if (that.findFunsList[i].id == id) {
          //遍历找到对应的id
          like_id = that.findFunsList[i].like_id;
          if (cookie_mid.includes(id) || that.findFunsList[i].is_follow) {
            //说明已经关注过,取消关注
            for (var k = 0; k < that.findFunsList.length; k++) {
              if (that.findFunsList[k].like_id == like_id) {
                for (var j = 0; j < cookie_mid.length; j++) {
                  if (cookie_mid[j] == that.findFunsList[k].id) {
                    cookie_mid.splice(j, 1); //删除取消赞的mid
                  }
                }
                this.$store.dispatch("changeZanFun", cookie_mid);
                that.findFunsList[k].is_follow = 0; //其他同个人的也取消关注
              }
            }
          } else {
            for (var k = 0; k < that.findFunsList.length; k++) {
              if (that.findFunsList[k].like_id == like_id) {
                that.findFunsList[k].is_follow = 1; //其他同个人的也关注
                cookie_mid.unshift(that.findFunsList[k].id); //新增赞的mid
              }
            }
            this.$store.dispatch("changeZanFun", cookie_mid);
          }

          gettofollowcircle(like_id).then(res => {
            if (res.code == 200) {
              Toast("操作成功!");
            } else {
              Toast("操作失败!");
            }
          });
        }
      }
    },
    favorclick: function (e) {
      var id = e.currentTarget.dataset.id; //此处找到列表的id
      this.goodfllow(id);
    },
    gotocirclecontent: function (e) {
      let circleid = e.currentTarget.dataset.id;
      this.$router.push({
        name: "circlecontent",
        query: {
          id: circleid
        }
      });
    },
    gotocircledetails: function (e) {
      this.$router.push({
        name: "dynamicdetails",
        query: {
          id: e.currentTarget.dataset.id
        }
      });
    },
    onSearch: function () {
      this.getnewlist();
    },
    onClear: function () {
    },
    onChange: function () {
      if (this.value === "") {
        this.page = 0;
        this.loading = false;
        this.finished = false;
        this.getnewlist();
      }
    }
  },
  activated () {
    document.title = "发现";
    this.getnewlist();
  }
};
</script>
<style scoped>
.van-search__content {
  background: #f8f8f8;
}
.found_top {
  width: 100%;
  position: fixed;
  z-index: 90;
}
.found_container .circletab .circleul {
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #efefef;
  padding: 0 1.2rem;
  padding-top: 0.5rem;
  background: #fff;
}
.found_container .circletab .circleul li {
  font-size: 0.81rem;
  text-align: center;
  color: #666666;
  flex: 0 0 33.333%;
}
.found_container .circletab .circleul li span {
  padding: 0.5rem 0;
  display: inline-block;
}
.found_container .circletab .circleul li.active {
  color: #ffbd0a;
}
.found_container .circletab .circleul li.active span {
  border-bottom: 3px solid #ffbd0a;
}
.circlemain {
}

.found_container {
  padding-bottom: 3.1rem;
  background: #f8f8f8;
}
.sosobox {
  transition: opacity 0s ease-in-out;
}
.sosobox .cu-bar .buttonbtn {
  color: #fff;
}
.findbigbox {
  column-count: 2;
  column-gap: 0.05405405405405406rem;
  width: 96%;
  /*  padding-bottom: 3.810811rem; */
  padding-left: 2%;
  padding-top: 104px;
}
.findbigbox .findcellbox {
  width: 96%;
  background: #fefefe;
  margin-top: 0.5405405405405406rem;
  padding: 0.02702702702702703rem;
  padding-bottom: 0.13513513513513514rem;
  transition: opacity 0.4s ease-in-out;
  display: inline-block;
  margin-right: 4%;
  border-radius: 0.2702702702702703rem;
}
.nofollowbox {
  padding-top: 204px;
  text-align: center;
}
.nofollowbox .nofollowpic {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
  margin: 0 auto;
}
.nofollowbox .nofollowpic img {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
}
.nofollowbox .nosearchtext {
  text-align: center;
  padding-top: 1.3513513513513513rem;
  font-size: 0.7567567567567568rem;
  color: #999;
}
.search-icon {
  font-size: 0.7837837837837838rem;
  font-weight: bold;
  color: #a4a4a4;
}
.icon-search {
  font-size: 0.7567567567567568rem;
  color: #999;
}

.findtempbox {
}
.findtempbox .findtempimgbox {
  position: relative;
}
.findtempbox .findtempimgbox .thumb {
  width: 100%;
  max-height: 13.513513513513514rem;
  min-height: 10rem;
  border-top-left-radius: 0.2702702702702703rem;
  border-top-right-radius: 0.2702702702702703rem;
}
.findtempbox .findtempimgbox .videoicon {
  position: absolute;
  top: 0.5405405405405406rem;
  right: 0.4864864864864865rem;
}
.findtempbox .findtempimgbox .videoicon img {
  width: 1.5135135135135136rem;
  height: 1.5135135135135136rem;
}
.findtempbox .findtempimgbox .authtitlebox {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.findtempbox .findtempimgbox .authtitlebox .authtitle-left {
  float: left;
  padding-left: 0.5405405405405406rem;
  padding-bottom: 0.2702702702702703rem;
}
.findtempbox .findtempimgbox .authtitlebox .authtitle-left img {
  border-radius: 50%;
  width: 1.2432432432432432rem;
  height: 1.2432432432432432rem;
  border: 0.08108108108108109rem solid #fff;
}
.findtempbox .findtempimgbox .authtitlebox .authtitle-right {
  float: right;
  text-align: right;
  padding-right: 0.5405405405405406rem;
  padding-top: 0.13513513513513514rem;
}
.findtempbox .findtempimgbox .authtitlebox .authtitle-right img {
  width: 0.918918918918919rem;
  height: 0.972972972972973rem;
  margin-bottom: -0.08108108108108109rem;
}
.findtempbox .findtempimgbox .authtitlebox .authtitle-right span {
  color: #f6f6f6;
  padding-left: 0.2702702702702703rem;
}
.findtempbox .findtemptitlebox {
  width: 92%;
  margin: 0 auto;
  background: #fff;
  padding-bottom: 0.5405405405405406rem;
}
.findtempbox .findtemptitlebox .findtemptext {
  padding-bottom: 0.5405405405405406rem;
  font-size: 0.7027027027027027rem;
  color: #333;
}
.findtempbox .findtemptitlebox .findtitile-downbox {
  overflow: hidden;
}
.findtempbox .findtemptitlebox .findtitile-downbox .authorfllow {
  float: right;
}
.findtempbox .findtemptitlebox .findtitile-downbox .authorbox {
  float: left;
  width: 5.1rem;
  padding-top: 0.16216216216216217rem;
  font-size: 0.6486486486486487rem;
  /* overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
     */
  color: #666;
}
.findtempbox .findtemptitlebox .findtitile-downbox .authorbox img {
  width: 0.918918918918919rem;
  height: 0.8918918918918919rem;
  margin-bottom: -0.13513513513513514rem;
}
.findtempbox .findtemptitlebox .findtitile-downbox .authorbox span {
  padding-left: 0.21027rem;
}
.findtempbox .findtemptitlebox .findtitile-downbox .authorfllow button {
  font-size: 0.5945945945945946rem;
  color: #ffbd0a;
  border: 1px solid #ffbd0a;
  width: 2.6486486486486487rem;
  display: block;
  padding: 0;
  background: #fff;
  outline: none;
  line-height: 1.0810810810810811rem;
  border-radius: 0.235135rem;
}
.findtempbox .findtemptitlebox .findtitile-downbox .unfollow button {
  color: #666;
  border: 1px solid #666;
}
.findtempbox .findtemptitlebox .findtitile-downbox .authorfllow button::after {
  border: none;
}
.findtempbox .findtemptitlebox .findtitile-downbox .authorfllow button.active {
  background: #dbdbdb;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/found.vue